import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components'
import Modal from "../../../../../../components/modal";
import {P} from "../../../../../../components/p";
import Input from "../../../../../../components/input";
import Button from "../../../../../../components/button";
import Spinner from "../../../../../../components/spinner";
import {adminFirebase, db, myFirebase} from "../../../../../../firebase/firebase";
import {connect} from "react-redux";
import axios from "axios";
import {API_URL} from "../../../../../../theme/constans";
import {StyledErrorMessage} from "../../../../../../theme/styledComponents";


function SaveNew ({user,onBack,refresh}) {
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState('');
    const [state,setState] = useState({
        role:'worker',
        name:'',
        phone:'',
        email:'',
        password:'',
        commission:2,
    });

    const onSave = () => {
        setLoading(true);

        const config = {
            headers: {
                Authorization: `Bearer ${user.token}`
            }
        };

        axios.get(`${API_URL}/createUser?email=${state.email}&password=${state.password}&name=${state.name}&phone=${state.phone}&role=${state.role}&commission=${state.role === 'partner' ? state.commission : 0}`,config)
            .then(response => {
                setLoading(false);
                refresh();
                onBack();
            }).catch(err => {
                setLoading(false);
                setError('Nie udało sie utworzyć nowego konta.');
        })
    };

    const handleDoubleInputChange = (e) => {
        if (e.target.value === "" || /^[0-9]+\.?[0-9]*$/.test(e.target.value)) {
            setState({...state,[e.target.name]:e.target.value});
        }
    };

    return(
        <>
            <Modal title="Dodaj nowe konto" onBack={onBack}>
                <P>Podaj dane nowego użytkownika.</P>

                <WrapperRadio>
                    <RadioButton active={state.role === 'worker'} onClick={(e) => setState({...state,role:'worker'})}>
                        Pracownik
                    </RadioButton>
                    <RadioButton active={state.role === 'partner'} onClick={(e) => setState({...state,role:'partner'})}>
                        Partner
                    </RadioButton>
                    <RadioButton active={state.role === 'dealer'} onClick={(e) => setState({...state,role:'dealer'})}>
                        Dealer
                    </RadioButton>
                </WrapperRadio>
                <Input label="Nazwa" value={state.name} onChange={(e) => setState({...state,name:e.target.value})}/>
                <Input label="Email" value={state.email} onChange={(e) => setState({...state,email:e.target.value})}/>
                <Input label="Hasło" type="password" value={state.password} onChange={(e) => setState({...state,password:e.target.value})}/>
                <Input label="Telefon" value={state.phone} onChange={(e) => setState({...state,phone:e.target.value})}/>
                {state.role === 'partner' && <Input label="Dodatkowa prowizja" name="commission" value={state.commission} onChange={handleDoubleInputChange}/>}
                {error !== '' && <StyledErrorMessage textAlign="center" margin="20px 0 0 0">{error}</StyledErrorMessage>}
                <Button
                    big
                    margin="20px 0 0 0"
                    disabled={state.name.length < 1 || state.email.length < 1 || state.password.length < 6 || state.phone.length < 1 || state.commission === ""}
                    onClick={onSave}
                >
                    {
                        loading ?
                            <Spinner borderWidth={3} white width={10} height={10}/> :
                            <>Dodaj konto</>
                    }
                </Button>
            </Modal>
        </>
    )
};

SaveNew.propTypes = {
};

function mapStateToProps(state) {
    return {
        user: state.auth.user,
    };
}
export default connect(mapStateToProps)(SaveNew);

const RadioButton = styled.div`
   background: none;
   color: ${({theme}) => theme.secondColor};
   padding: 3px 5px;
   text-align: center;
   border-radius: 3px;
   font-weight: 500;
   cursor: pointer;
   transition: all 0.3s;
   
   &:hover{
    color: ${({theme}) => theme.primaryColor};
   }
   ${({active}) => active && 
    css`
      background: ${({theme}) => theme.primaryColor};
      color: white !important;
  `}
   
 
`;

const WrapperRadio = styled.div`
  margin-top: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 3px;
  border-radius: 3px;
  background: ${({theme}) => theme.fourthColor};
`;
